import React from 'react';

import PromotionList from 'components/Tvendo/Article/Operations/Promotion/List.js';

export default function () {
  return <PromotionList />;
}
